import * as msal from "@azure/msal-browser";
import { IUser } from "@/models/IUser";
import { IUserGraph } from "@/models";

interface IAccountState {
    msalAccount: msal.AccountInfo | null;
    user: IUser | null;
    userGraph: IUserGraph | null;
    userPhoto: string | null;
}

const initialState: IAccountState = {
    msalAccount: null,
    user: null,
    userGraph: null,
    userPhoto: null,
};

export { IAccountState, initialState };
